import { createNavigateToNextOnboardingPageAction } from "@actions/navigateToNextOnboardingPageActionFactory"

const ORDERED_ONBOARDING_ROUTES_V3 = [
  "gender",
  "age",
  "company",
  "tryFirst",
  "unleashLook",
  "firstImpression",
  "tryFirstSub",
  "styleFeeling",
  "hairstyleFrequency",
  "boldLooks",
  "sharePhoto",
  "experimentingLook",
  "doingAmazing",
  "confidenceBoost",
  "photoWinPreview",
  "futureLook",
  "personality",
  "compliment",
  "styleProfile",
  "readyToTransform",
  "photoUsage",
  "subscriptionCount",
  "almostThere",
] as const

const navigateToNextOnboardingPageActionV3 =
  createNavigateToNextOnboardingPageAction(ORDERED_ONBOARDING_ROUTES_V3)

export default navigateToNextOnboardingPageActionV3
